import { IPublishTerms } from './publishTerms';
import { EMoneySource } from '../../user';

export interface IPublishTermsState extends IPublishTerms {
  /** Флаг активности Новой ФВУ */
  isNewPublishTermsEnabled: boolean;
  /** Статус загрузки услуг размещения */
  status: EPublishTermsStatus;
  /** Ошибка сервера */
  error: string | null;
  /** Признак эксперимента MONEY-382 **/
  withoutMinimalBet: boolean;
  /** Признак выключенного продвижения **/
  withoutPromotion: boolean;
  /** Флаг активности продвижения в поиске */
  isServicesEnabled: boolean;
  /** Счёт размещения **/
  moneySource: EMoneySource | null;
}

export enum EPublishTermsStatus {
  initial = 'initial',
  pending = 'pending',
  success = 'success',
  fail = 'fail',
}
